import styled, { css } from "styled-components";

export const Container = styled.button`
  ${({ theme, size, typeButton }) => css`
    background: ${theme.buttons[typeButton].background};
    color: ${theme.buttons[typeButton].color};
    border: ${theme.buttons[typeButton].border};
    transition: all 0.4s;
    padding: 6px 13px;
    border-radius: 40px;
    cursor: pointer;
    line-height: 1.5;

    :hover {
      background: ${theme.buttons[typeButton].hover.background};
      color: ${theme.buttons[typeButton].hover.color};
      border: ${theme.buttons[typeButton].hover.border};
    }

    font-size: ${theme.fontButtons[size].fontSize};
    font-weight: ${theme.fontButtons[size].fontWeight};
    font-family: ${theme.fontButtons[size].fontFamily};

    @media screen and (max-width: 1024px) {
      background: ${theme.buttons[`${typeButton}Mobile`].background};
      color: ${theme.buttons[`${typeButton}Mobile`].color};
      border: ${theme.buttons[`${typeButton}Mobile`].border};

      :hover {
        background: ${theme.buttons[`${typeButton}Mobile`].hover.background};
        color: ${theme.buttons[`${typeButton}Mobile`].hover.color};
        border: ${theme.buttons[`${typeButton}Mobile`].hover.border};
      }

      font-size: ${theme.fontButtons[`${size}Mobile`].fontSize};
      font-weight: ${theme.fontButtons[`${size}Mobile`].fontWeight};
      font-family: ${theme.fontButtons[`${size}Mobile`].fontFamily};
    }
  `}
`;
